import AutoAwesomeMosaicIcon from '@mui/icons-material/AutoAwesomeMosaic';

import { ContextMetadataModel, EnumModel } from '../../../../api/api';
import useApiEnumsOfContext from '../../Hooks/useApiEnumsOfContext';
import { EnumReference } from '../../Models/EnumReference';
import GenericContextInputItemDialog from './GenericContextInputItemDialog';

type EnumerationInputDialogProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
	enumRef: EnumReference | undefined;
	onEnumRefChange: (enumRef: EnumReference | undefined) => void;
	onEnumSelected?: (enumModel: EnumModel | undefined, context?: ContextMetadataModel | undefined) => void;
};

export function EnumerationInputDialog({ open, setOpen, enumRef, onEnumRefChange, onEnumSelected }: EnumerationInputDialogProps) {
	return (
		<GenericContextInputItemDialog
			open={open}
			setOpen={setOpen}
			item={enumRef ? ({ id: enumRef.Id, name: enumRef.Name, contextId: enumRef.ContextId } as any) : undefined}
			onItemChange={(item, context) => {
				onEnumRefChange?.(item ? ({ Id: item.id, Name: item.name, ContextId: item.contextId || context?.id } as EnumReference) : undefined);
				onEnumSelected?.(item as EnumModel | undefined, context);
			}}
			itemsOfContext={useApiEnumsOfContext}
			what="Enumeration"
			descriptionProperty="description"
			icon={() => <AutoAwesomeMosaicIcon fontSize="small" />}
		/>
	);
}
